
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	@Component({
		name: 'bcgl'
	})
	export default class bcgl extends Vue {
		bcxxDataList: Array < any > = [];
		bcxxData: any = {};
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		showBcxxVisible: boolean = false;
		searchText: string = '';
		loading: boolean = false;

		created() {
			this.searchData();
		}
		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}
		searchData() {
			this.loading = true;
			this.$request({
					url: '/bjba/bcxx/search',
					method: 'get',
					params: {
						currentNo: this.currentNo,
						pageSize: this.pageSize,
						bcxxName: `%${this.searchText}%`
					}
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.bcxxDataList = data.data.content;
						console.log(this.bcxxDataList);
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(msg)
				});
		}
		showBcxx(val: any) {
			this.bcxxData = { ...val };
			this.showBcxxVisible = true;
		}
		saveBcxx(bcxx: any) {
			console.log(this.bcxxData);
			this.$request({
					url: '/bjba/bcxx/save',
					method: 'post',
					data: this.bcxxData
				})
				.then(response => {
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.$message.success(data.message)
						this.showBcxxVisible = false;
						this.searchData();
					} else {
						this.$message.error(data.message)
					}

				})
				.catch(error => {
					console.log(error)
					this.$message.error(msg)
				});
		}
		deleteBcxx(bcid: String) {
			this.$confirm('是否确定删除此班次信息', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$request({
						url: '/bjba/bcxx/delete',
						method: 'get',
						params: {
							bcxxId: bcid
						}
					})
					.then(response => {
						let data = response.data;
						if (data.code == 200) {
							this.$message.success(data.message)
						} else {
							this.$message.error(data.message)
						}
						this.searchData();
					})
					.catch(error => {
						console.log(error)
						this.$message.error(msg)
					});
			}).catch(() => {});
		}
	}
